import React from "react";
import CreateAppBtn, { ICreateAppBtnProps } from "./CreateAppBtn";
import apiConnect from "../../assets/images/welcome-api-connect.png";
export interface INoAppComponentProps extends ICreateAppBtnProps {}

const NoAppComponent: React.FC<INoAppComponentProps> = (props) => {
  return (
    <div className="apiConnectWrap">
      <div className="apiConnect">
        <img
          src={apiConnect}
          alt="Welcome api connect"
          className="connectImg"
        />
        <h1>Welcome to Nuvama Api Connect</h1>
        <p>Your Free subscription for Nuvama Api Connect is</p>
        <p>started. Start your journey by creating your first App</p>
        <div className="app_create_btn">
          <CreateAppBtn
            appFormHandler={props.appFormHandler}
            title={props.title}
          />
        </div>
      </div>
    </div>
  );
};

export default NoAppComponent;
